import { httpRequest } from "@services/http";
import {
  ConversionRuleEntity,
  ConversionRuleSchemaResponse,
} from "@models/conversionRuleSchema.model";

export class CommandGetConversionRuleSchema {
  async run(organizationId: number): Promise<ConversionRuleEntity[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/audiences/organizations/${organizationId}/configs/`;
    const response = await httpRequest<ConversionRuleSchemaResponse>(url, { method: "GET" });
    return response.entities;
  }
}
